/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PartialLabelData } from './PartialLabelData';

/**
 * CatalogItemOut schema for update webhooks, containing the object after the update alongside the fields that changed
 */
export type CatalogItemUpdatedWebhookData = {
  /**
   * The event that triggered this webhook, for example order.created
   */
  type: CatalogItemUpdatedWebhookData.type;
  /**
   * Catalog item id
   */
  id: string;
  /**
   * Id of the account that owns the item
   */
  account_id: string;
  /**
   * Id of the catalog category the item belongs to
   */
  category_id: string;
  /**
   * Item name, per language
   */
  name: PartialLabelData;
  /**
   * Item description, per language
   */
  description?: PartialLabelData;
  /**
   * Item photo URL
   */
  photo_url?: string;
  /**
   * Unit price in the account currency
   */
  price: number;
  /**
   * Free-form tags of the item
   */
  tags?: Array<string>;
  /**
   * True once the item is deleted
   */
  archived?: boolean;
  /**
   * UTC time the item was created
   */
  created_at: string;
  /**
   * UTC time the item was last updated
   */
  updated_at: string;
  /**
   * The fields that changed, holding the value they had before this update. Only changed fields are included. A field that had no value before appears as null, an updated nested object contains only its changed keys, and an updated list is included in full.
   */
  previous_attributes: {
    /**
     * Catalog item id
     */
    id?: string;
    /**
     * Id of the account that owns the item
     */
    account_id?: string;
    /**
     * Id of the catalog category the item belongs to
     */
    category_id?: string;
    /**
     * Item name, per language
     */
    name?: PartialLabelData;
    /**
     * Item description, per language
     */
    description?: PartialLabelData;
    /**
     * Item photo URL
     */
    photo_url?: string;
    /**
     * Unit price in the account currency
     */
    price?: number;
    /**
     * Free-form tags of the item
     */
    tags?: Array<string>;
    /**
     * True once the item is deleted
     */
    archived?: boolean;
    /**
     * UTC time the item was created
     */
    created_at?: string;
    /**
     * UTC time the item was last updated
     */
    updated_at?: string;
  };
};

export namespace CatalogItemUpdatedWebhookData {
  /**
   * The event that triggered this webhook, for example order.created
   */
  export enum type {
    CATALOG_ITEM_CREATED = 'catalog_item.created',
    CATALOG_ITEM_UPDATED = 'catalog_item.updated',
    CATALOG_ITEM_DELETED = 'catalog_item.deleted',
  }
}
